var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intes-bt"},[_c('img',{staticClass:"intes-bt-bg",attrs:{"src":require("@/assets/image/anxin/nyhead.png")}}),_c('div',{staticClass:"intes-bt-img"},[_c('img',{attrs:{"src":require("@/assets/image/anxin/nyjf.png")}})]),_c('div',{staticClass:"intes-bt-test"},[_c('div',{style:({
        color:
          _vm.marks <= 60
            ? '#D45353'
            : _vm.marks >= 61 && _vm.marks <= 74
            ? '#f1be33'
            : _vm.marks >= 75 && _vm.marks <= 84
            ? '#9ef133'
            : '#28d200',
      })},[_c('b',[_c('NumberGrow',{attrs:{"value":_vm.marks,"fontSize":'0.96rem',"fontWeight":'bold'}})],1),_vm._v("分 ")]),_c('p',[_vm._v(_vm._s(_vm.name)+"总分")])]),_c('div',{staticClass:"intes-bt-fs",on:{"click":_vm.handClickFs}},[_vm._v("分数说明")])])}
var staticRenderFns = []

export { render, staticRenderFns }